import React from "react";
import { Column, Bar } from "@ant-design/charts";

export default function Index(props) {
  const config = {
    data: props.data.map((item) => ({
      ...item,
      value: parseFloat(item.value),
    })),
    xField: props.type == "bar" ? "value" : "year",
    yField: props.type == "bar" ? "year" : "value",
    isGroup: true,
    isStack: true,
    marginRatio: 0.3,
    seriesField: "sector",
    groupField: "name",
    legend: {
      position: "right-top",
    },
    tooltip: {
      formatter: (datum) => {
        return { name: datum.name };
      },
    },
  };

  if (props.type === "bar") {
    return <Bar {...config} />;
  }

  if (props.type === "column") {
    return <Column {...config} />;
  }

  return false;
}
